import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import { hoistStatics } from 'recompose';

import { Flex, Box, Image, Text, ButtonFilled, Link } from 'Components/Base';

const FeedbackReportComplete = ({ t, variant = VARIANTS.REPORT, onContinue }) => {
  return (
    <Flex width={1} flexDirection={'column'} alignItems={'center'}>
      {variant === VARIANTS.REPORT && (
        <Image maxWidth={60} src="/assets/images/feedback/comment.svg" />
      )}
      {variant === VARIANTS.LIKE && <Image maxWidth={75} src="/assets/images/feedback/like.svg" />}
      <Box mt={6} />
      <Flex width={1} flexDirection={'column'} alignItems={'center'}>
        <Text textStyle={'heading4'} textAlign={'center'}>
          <Trans
            defaults={t('FEEDBACK_REPORT.COMPLETE.THANKYOU')}
            components={[<br key="title" />]}
          />
        </Text>
        <Text textStyle={'body2'} mt={4} textAlign={'center'}>
          <Trans
            defaults={t('FEEDBACK_REPORT.COMPLETE.DESCRIPTION')}
            components={[<br key="subtitle" />]}
          />
        </Text>
        {typeof onContinue === 'function' && (
          <Link onClick={onContinue} width={1} maxWidth={'300px'}>
            <ButtonFilled mt={4} width={1} borderRadius="8px">
              {t('FEEDBACK_REPORT.COMPLETE.CONTINUE')}
            </ButtonFilled>
          </Link>
        )}
      </Flex>
    </Flex>
  );
};

const VARIANTS = { LIKE: 'LIKE', REPORT: 'REPORT' };

FeedbackReportComplete.propTypes = {
  onContinue: PropTypes.func,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
};

FeedbackReportComplete.VARIANTS = VARIANTS;

export default hoistStatics(withTranslation('feedback'))(FeedbackReportComplete);
